/**
 * 设置table高度
 * @param {this} thisObj 参数为this
 */
function SetTableH(thisObj, opreationName) {
  let _this = thisObj
  _this.$nextTick(() => {
    let opreationBoxDom = opreationName
      ? document.querySelector(opreationName)
      : document.querySelector('.opreationBox')
    let headerDom = document.querySelector('#header')
    let pageBox = document.querySelector('.pageBox')
    // 40 为el-main 的上下边距 20为pageBox 的Margin-top
    let otherPaddingMargin = 40 + 20
    let clientHeight =
      document.documentElement.clientHeight == 0
        ? document.body.clientHeight
        : document.documentElement.clientHeight
    let tableH =
      clientHeight -
      (headerDom.offsetHeight +
        opreationBoxDom.offsetHeight +
        pageBox.offsetHeight +
        otherPaddingMargin)
    _this.tableH = tableH
    window.onresize = () => {
      let tableH =
        clientHeight -
        (headerDom.offsetHeight +
          opreationBoxDom.offsetHeight +
          pageBox.offsetHeight +
          otherPaddingMargin)
      _this.tableH = tableH
    }
  })
}

function JumpToLogin() {
  window.sessionStorage.removeItem('token')
  window.sessionStorage.removeItem('loginuser')
  // let url = ''
  // switch (process.env.VUE_APP_Version) {
  //   case 'dev':
  //     url = `${process.env.VUE_APP_BaseUrl}/login`
  //     break
  //   case 'test':
  //     url = `http://sa.personfg.com:8090/login`
  //     break
  //   case 'pro':
  //     url = `http://sa.personfg.com:8090/login`
  //     break
  // }
  window.location.href = `${process.env.VUE_APP_BaseUrl}/login`
}

export { SetTableH, JumpToLogin }
